// RACKs.js

export const TK_RACK_CREATE = "TK_RACK_CREATE";
export const TK_RACK_DELETE = "TK_RACK_DELETE";

export default function tkRack(state = {}, action) {
  switch (action.type) {

    case TK_RACK_CREATE:
      return Object.assign({}, state, action.tkRack);

    case TK_RACK_DELETE:
      return Object.assign({}, {}, {});


    default:
      return state;
  }
}
